var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1381 16.1701V19.1701C21.1392 19.4486 21.0822 19.7243 20.9706 19.9794C20.8591 20.2346 20.6954 20.4637 20.4902 20.652C20.285 20.8402 20.0427 20.9836 19.7789 21.0728C19.515 21.162 19.2355 21.1952 18.9581 21.1701C15.881 20.8357 12.9251 19.7842 10.3281 18.1001C7.91194 16.5648 5.86345 14.5163 4.32812 12.1001C2.6381 9.4913 1.58636 6.52109 1.25812 3.4301C1.23313 3.15356 1.26599 2.87486 1.35462 2.61172C1.44324 2.34859 1.58569 2.10679 1.77288 1.90172C1.96008 1.69665 2.18792 1.53281 2.44191 1.42062C2.69589 1.30843 2.97046 1.25036 3.24812 1.2501H6.24812C6.73342 1.24532 7.20391 1.41718 7.57188 1.73363C7.93985 2.05008 8.18019 2.48954 8.24812 2.9701C8.37474 3.93016 8.60957 4.87282 8.94812 5.7801C9.08266 6.13802 9.11178 6.52701 9.03202 6.90098C8.95227 7.27494 8.76698 7.61821 8.49812 7.8901L7.22812 9.1601C8.65167 11.6636 10.7246 13.7365 13.2281 15.1601L14.4981 13.8901C14.77 13.6212 15.1133 13.4359 15.4872 13.3562C15.8612 13.2764 16.2502 13.3056 16.6081 13.4401C17.5154 13.7786 18.4581 14.0135 19.4181 14.1401C19.9039 14.2086 20.3475 14.4533 20.6646 14.8276C20.9818 15.2019 21.1503 15.6797 21.1381 16.1701Z",
    stroke: "#090A0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.377e2d86b822e9b0d614b809a56e0c15.svg";
export { ForwardRef as ReactComponent };